import { createSpatialViewInterface, FetchGlbUrlPayload, FetchLivePollingPayload, FetchSensorDevicesPayload, FetchSpatialViewOperationsPayload, FetchTatamDevicesPayload, FetchTotalDevicesPayload, InstallSpatialViewDevicePayload, UninstallSpatialViewDevicePayload } from "redux/types/spatialViewActionModel";
import { http_delete, http_get, http_post, http_put } from "./BaseURLAxios";
import { CREATE, FLOORPLAN, INSTALL, OPERATIONS, POLLING, POLLING_LIVE, SPATIAL_VIEW, UNINSTALL } from "./urlConstants";

export const getSpatialViewCustomersAPI = async (id?: string) => {
    let url = SPATIAL_VIEW;
    if (id) {
        url += `?org_id=${id}`;
    }
    return await http_get(url).then((res: any) => res);
};

export const createSpatialViewCustomersAPI = async (body: createSpatialViewInterface) => {
    return await http_post(SPATIAL_VIEW + '/' + CREATE,body).then((res: any) => {
        return res;
    });
};
export const uploadFileToPresignedUrl = async (presignedUrl: string, file: File): Promise<void> => {
    const response = await fetch(presignedUrl, {
        method: 'PUT',
        headers: {
            "Content-Type": "model/gltf-binary"
          },
        body: file
    });
};

export const updateSpatialViewCustomersAPI = async (body: Partial<createSpatialViewInterface> & { spatial_view_id: number }) => {
    const { spatial_view_id, ...apiBody } = body;
    return await http_put(`${SPATIAL_VIEW}/${spatial_view_id}`, apiBody).then((res: any) => {
        return res;
    });
};

export const fetchGlbUrlAPI = async (params: FetchGlbUrlPayload) => {
    return await http_get(`${SPATIAL_VIEW}/${params.spatial_model_id}/${FLOORPLAN}`).then((res: any) => res);
};

export const deleteSpatialViewAPI = async (spatial_view_id: number) => {
    return await http_delete(`${SPATIAL_VIEW}/${spatial_view_id}`).then((res: any) => {
        return res;
    });
};

export const updateModelAPI = async (spatial_view_id: number) => {
    const body={}
    return await http_put(`${SPATIAL_VIEW}/${spatial_view_id}/floor-plan`,body).then((res: any) => {
        return res;
    });
};
export const fetchSensorDevicesAPI = async (params: FetchSensorDevicesPayload) => {
    return await http_get(
        `${SPATIAL_VIEW}/get-sensor-devices?device_type=${params.device_type}&org_id=${params.org_id}`
    ).then((res: any) => res);
};
export const installSpatialViewDeviceAPI = async (body: InstallSpatialViewDevicePayload) => {
    return await http_post(`${SPATIAL_VIEW}/${INSTALL}`, body).then((res: any) => res);
};
export const uninstallSpatialViewDeviceAPI = async (body: UninstallSpatialViewDevicePayload) => {
    return await http_post(`${SPATIAL_VIEW}/${UNINSTALL}`, body).then((res: any) => res);
};
export const fetchTotalDevicesAPI = async (params: FetchTotalDevicesPayload) => {
    return await http_get(
        `${SPATIAL_VIEW}/devices-count?org_id=${params.org_id}&spatial_view_id=${params.spatial_view_id}`
    ).then((res: any) => res);
};
export const fetchLivePollingAPI = async (params: FetchLivePollingPayload) => {
    return await http_get(
        `${POLLING}/${POLLING_LIVE}?org_id=${params.org_id}&spatial_view_id=${params.spatial_view_id}`
    ).then((res: any) => res);
};
export const fetchSpatialViewOperationsAPI = async (params: FetchSpatialViewOperationsPayload) => {
    return await http_get(
        `${SPATIAL_VIEW}/${OPERATIONS}?spatial_view_id=${params.spatial_view_id}&org_id=${params.org_id}`
    ).then((res: any) => res);
};